// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./ModalContent";
export * from "./ModalContent";
export { ModalContentActionIcon } from "./ModalContent.styled";
export type { CommonModalProps } from "./types";
export { ModalHeader } from "./ModalHeader";
export type { ModalHeaderProps } from "./ModalHeader";
